import { render, staticRenderFns } from "./tag-selector.vue?vue&type=template&id=414a6ae7&"
import script from "./tag-selector.vue?vue&type=script&lang=js&"
export * from "./tag-selector.vue?vue&type=script&lang=js&"
import style0 from "./tag-selector.vue?vue&type=style&index=0&id=414a6ae7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports